<button
  *ngIf="citation?.html"
  [innerHTML]="citation.html"
  (click)="itemClicked.emit($event)"
  [attr.aria-expanded]="isExpanded"
  attr.aria-controls="item_{{ item.id }}_detail"
  class="btn btn-link btn-link-xs u-mr1 user-select-auto c-list-item__citation"
  type="button"
></button>

<div *ngIf="citation?.error" class="c-list-item__citation-error">
  <rl-fielded-resource
    [resource]="item.resource"
    [isClickable]="true"
    (resourceClicked)="itemClicked.emit($event)"
  >
  </rl-fielded-resource>
</div>

<rl-citation-placeholder *ngIf="!citation?.html && !citation?.error">
</rl-citation-placeholder>

<ul *ngIf="item.importance?.description" class="list-unstyled u-mb0">
  <li class="c-list-item__field c-list-item__field--importance">
    {{ item.importance.description }}
  </li>
</ul>
